<template>
  <el-dialog :title="dialogTitle" :visible.sync="DialogShow" @close="DialogOnClose" :width="dialogType == 'ViewDetails' ? '600px' : '480px'">
    <div class="dialog_box">
      <div v-if="dialogType == 'ViewReturnInfo'">
        <!-- 查看退货信息 -->
        <div class="sh_fee">
          <div>{{ $t('enum.carrier') }}:</div>
          <div>{{ CardInfo.ExpressName }}</div>
        </div>
        <div class="sh_fee">
          <div>{{ $t('enum.trackingNumber') }}:</div>
          <div>{{ CardInfo.Express }}</div>
        </div>
      </div>
      <div v-if="dialogType == 'Ship' || dialogType == 'ChangeShippingInfo'">
        <!-- 填写/修改 运输信息 -->
        <div class="sh_fee_y">
          <div>{{ $t('enum.carrier') }}</div>
          <el-select class="enter_y" v-model="CardInfo.ExpressName" value-key="ShipperName" @change="setExpress($event)" filterable data-live-search="true" :placeholder="$t('enum.carrierName')">
            <el-option v-for="(item, k) in $store.state.ExpressShipper" :key="k" :label="item.ShipperName" :value="item" :disabled="item.ShipperCode ? false : true"></el-option>
          </el-select>
        </div>
        <div class="sh_fee_y">
          <div>{{ $t('enum.trackingNumber') }}</div>
          <el-input class="enter_y" v-model="CardInfo.Express" :placeholder="$t('enum.enterTrackingNumber')"></el-input>
        </div>
        <div class="sh_fee_x ship-val-row">
          <div class="sh_f_l">{{ $t('enum.buyerID') }}:</div>
          <div class="sh_f_r">{{ CardInfo.BuyerName ? CardInfo.BuyerName : "" }}</div>
        </div>
        <div class="sh_fee_x ship-val-row">
          <div class="sh_f_l">{{ $t('enum.contactNumber') }}:</div>
          <div class="sh_f_r">{{ CardInfo.Mobile ? CardInfo.Mobile : '' }}</div>
        </div>
        <div class="sh_fee_x ship-val-row">
          <div class="sh_f_l">{{ $t('enum.shippingAddress') }}:</div>
          <div class="sh_f_r">{{ CardInfo.Nation ? CardInfo.Nation : '' }} - {{ CardInfo.City ? CardInfo.City : '' }},
            {{ CardInfo.Provice ? CardInfo.Provice : '' }}, {{ CardInfo.Address ? CardInfo.Address : '' }}</div>
        </div>
      </div>
      <div v-if="dialogType == 'ViewDetails'">
        <!-- 查看订单详细 -->
        <card-detail :CardInfo="CardInfo"></card-detail>
      </div>
      <div v-if="dialogType == 'ViewPhotos'">
        <!-- 查看跨境订单信息 -->
        <!-- OrderCheckStatus: -1待查验，0不通过，1通过并放款，2通过待买家确认 -->
        <div v-if="OrderCheck.OrderId && OrderCheck.OrderStatus > -1 && OrderCheck.data && OrderCheck.data.length" class="photos_list">
          <div class="photo_block" v-for="(obj, k) in OrderCheck.data" :key="k">
            <el-image class="photo_img" :src="obj.ImgUrl + $store.state.thumbnail" fit="contain" :preview-src-list="getPreviewList(k)"></el-image>
            <p class="photo_des">{{ obj.Describe }}</p>
          </div>
        </div>
        <div v-else class="text_333 align_c">Card Hobby Confirming...</div>
      </div>
      <div v-if="dialogType == 'EditShippingFee'">
        <!-- 修改运费 -->
        <div class="sh_fee">
          <div>{{ $t('enum.shippingFee') }}:</div>
          <div>
            {{
              ['paid on delivery', '到付', 'pay on delivery', '顺丰到付'].includes(CardInfo.NewPostageMoney.toLowerCase()) ? $t('newItem.payOnDelivery') : (CardInfo.USDRate ? (CardInfo.PostageMoney * CardInfo.USDRate).toFixed(2) : '')
            }}
          </div>

        </div>
        <div class="sh_fee">
          <div>{{ $t('enum.newShippingFee') }}:</div>
          <div class="sh_ipt" style="display: flex;flex-direction: column;">
            <div>
              USD &nbsp;<el-input class="enter_price" v-model="Price" :placeholder="$t('enum.enterPrice')"></el-input>
            </div>
            <div>
              <el-radio v-model="ArrivalPay" :label="1">{{ $t('newItem.payOnDelivery') }}</el-radio>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="dialogType == 'ToBeReviewed'">
      <!-- 评论 -->
      <div class="review_dialog_box">
        <div class="review_dialog_top" v-if="k <= 0" v-for="obj, k in CardInfo.Details" :key="k">
          <div class="review_img">
            <img :src="obj.TitImg + $store.state.thumbnail" alt="">
          </div>
          <div class="review_detail">
            <div class="review_title">{{ obj.Title }}</div>
            <div class="review_buyer">
              <img v-if="CardInfo.HeadPortrait" class="headPortrait" :src="CardInfo.HeadPortrait + $store.state.thumbnail">
              <el-avatar v-if="!CardInfo.HeadPortrait" class="headPortrait" fit="fit" icon="el-icon-user-solid" size="small"></el-avatar>
              <div class="review_name">{{ CardInfo.BuyerName }}</div>
            </div>
          </div>
        </div>
        <div class="review_serve">
          <el-button class="review_button" @click="myReview(1)" :class="choose == 1 ? 'el-button--primary' : ''">
            <div class="review_button_div">
              <img ref="review_icon1" src="../../../static/images/icons/icon_thumbs_up.svg">
              <span>{{ $t('enum.good') }}</span>
            </div>
          </el-button>
          <el-button style="margin:0 0 0 16px;" class="review_button" @click="myReview(2)" :class="choose == 2 ? 'el-button--primary' : ''">
            <div class="review_button_div">
              <img ref="review_icon2" src="../../../static/images/icons/icon_thumbs_down_blue.svg">
              <span>{{ $t('enum.notGood') }}</span>
            </div>
          </el-button>
        </div>
        <el-input class="review_textarea" type="textarea" :rows="4" placeholder="something you want to say" maxlength="100" show-word-limit v-model="AppraisalContent"></el-input>
      </div>

    </div>
    <!-- 评论历史列表 -->
    <!-- AppraisalStatus 1好评 2差评 -->
    <!-- <div v-if="dialogType=='FeedbackDetail'">
        <div class="review_dialog_box">
          <div class="review_dialog_top" v-if="k<=0" v-for="obj,k in CardInfo.Details" :key="k">
            <div class="review_img">
              <img :src="obj.TitImg+$store.state.thumbnail" alt="">
            </div>
            <div class="review_detail">
              <div class="review_title">{{obj.Title}}</div>
              <div class="review_buyer">
                <img v-if="CardInfo.HeadPortrait" class="headPortrait" :src="CardInfo.HeadPortrait+$store.state.thumbnail">
                <span class="Price_ text_blue">$</span>
                <div class="Price_p text_blue">{{obj.Price}}</div>
              </div>
            </div>
          </div>
          <div>
            <div class="review_name_m" v-if="AppraisalList.length" v-for="(appobj,q) in AppraisalList" :key="q">
              <div class="review_buyer review_buyer_box">
                <img v-if="CardInfo.HeadPortrait" class="headPortrait" :src="CardInfo.HeadPortrait+$store.state.thumbnail">
                <el-avatar v-if="!CardInfo.HeadPortrait" class="headPortrait" fit="fit" icon="el-icon-user-solid" size="small"></el-avatar>
                <div>
                  <div class="review_name">{{CardInfo.BuyerName}}</div>
                  <div class="text_gray review_createDate">{{appobj.CreateDate?$store.getters.getTime(appobj.CreateDate.CreateDate,$store.state.tPST,'cmtNull','MMM DD, YYYY'):''}}</div>
                </div>
                <span class="evaluate_icon" :class="appobj.AppraisalStatus==1 ?'evaluate_good':'evaluate_notgood'"></span>
              </div>
              <div class="feedback-detail">
                <div class="fdtl-list">
                  {{appobj.AppraisalContent}}
                </div>
              </div>
            </div>
          </div>

        </div>

      </div> -->
    <div class="dialogBox-list" v-if="dialogType == 'ContactBuyer'">
      <div class="contact_box">

      </div>
    </div>
    <div class="dialogBox-list" v-if="dialogType == 'ContactCardHobby'">
      ContactCardHobby ContactCardHobby ContactCardHobby
    </div>
    <div class="dialogBox-list" v-if="dialogType == 'CloseOrder'">
      <div style="text-align: center;">Confirm close this order?</div>
    </div>
    <div class="dialogBox-list" v-if="dialogType == 'RestoreOrder'">
      <!-- 拆分订单 -->
      <div class="sh_fee_x ship-val-row">
        <div>{{ $t('enum.buyerID') }}:</div>
        <div class="flex">
          <el-avatar style="width: 22px;height: 22px;margin: 0 5px 0 0;" :src="CardInfo.BuyerHeadPortrait + $store.state.thumbnail"></el-avatar>
          {{ CardInfo.BuyerName }}
        </div>
      </div>
      <div class="sh_fee_x ship-val-row">
        <div>{{ $t('enum.orderNumber') }}:</div>
        <div>{{ CardInfo.Code }}</div>
      </div>
      <div class="sh_fee_x ship-val-row">
        <div>{{ $t('enum.qty') }}:</div>
        <div>{{ CardInfo.Details ? CardInfo['Details'].length : 1 }}</div>
      </div>
      <div class="sh_fee_x ship-val-row">
        <div>{{ $t('enum.shippingFee') }}:</div>
        <div>{{ (CardInfo.PostageMoney * CardInfo.USDRate).toFixed(2) }}</div>
      </div>
      <div class="split-tips text_gray">
        <!-- 拆分订单提示语 -->
        <p><b>{{ $t('enum.splitOrderTips.a') }}</b></p>
        <ul class="split-tips-li">
          <li>{{ $t('enum.splitOrderTips.b') }}</li>
          <li>{{ $t('enum.splitOrderTips.c') }}</li>
          <li>{{ $t('enum.splitOrderTips.d') }}</li>
        </ul>
      </div>
    </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <div v-if="['EditShippingFee', 'Ship', 'ChangeShippingInfo', 'ToBeReviewed'].indexOf(dialogType) > -1">
        <el-button @click="DialogShow = false">{{ $t('button.cancel') }}</el-button>
        <el-button type="primary" @click="saveData">{{ $t('button.save') }}</el-button>
      </div>
      <div v-else-if="['RestoreOrder'].indexOf(dialogType) > -1">
        <!-- 拆分订单 -->
        <el-button @click="DialogShow = false">{{ $t('button.no') }}</el-button>
        <el-button type="primary" @click="saveData">{{ $t('button.yes') }}</el-button>
      </div>
      <div v-else-if="['CloseOrder'].indexOf(dialogType) > -1">
        <!-- 关闭订单 -->
        <el-button @click="DialogShow = false">{{ $t('button.no') }}</el-button>
        <el-button type="primary" @click="saveData">{{ $t('button.yes') }}</el-button>
      </div>
      <div v-else>
        <!-- <el-button v-if="dialogType=='FeedbackDetail'" @click="DialogShow = false">Leave Feedback</el-button> -->
        <el-button type="primary" @click="DialogShow = false">{{ $t('button.done') }}</el-button>
      </div>
    </span>

  </el-dialog>
</template>

<script>

import CardDetail from '@/components/card-detail'
export default {
  name: 'DialogOrder',
  components: { CardDetail },
  data() {
    return {
      choose: 1,
      ExpressShipper: this.$store.state.ExpressShipper || [],
      ExpressForm: {
        Express: '',//快递号
      },//修改快递单号Form
      tabButton: false,
      cardDetail: false,
      DialogShow: false,
      OfferPrice: '',
      dialogType: '',
      CardInfo: {},
      ID: 0,
      textarea: '',
      checked: false,
      ShippingFeeMaxUsdPrice: 150,//最大运费美金价格
      Price: '',//邮费
      ArrivalPay: 0,//是否到付	到付 = 1, 不到付 = 0
      AppraisalType: 2,//评价类型	买家 = 1, 卖家 = 2
      AppraisalStatus: 1,//是否好评	好评 = 1, 差评 = 2
      AppraisalContent: '',//评价内容
      AppraisalList: [],//评论历史列表
      OrderCheck: {},//订单验收状态
      previewImgList: [],//预览图片
    }
  },
  props: {
    dialogTitle: ''
  },
  watch: {
    "ArrivalPay": function (val) {
      if (val == 1) {
        this.Price = '';
      }
    },
    "Price": function (val) {
      if (this.Price != '') {
        this.ArrivalPay = 0;
      }
    },
  },
  created() {
    // console.log('dialog created');
  },
  computed: {
    getPreviewList() {
      return function (k) {
        let list = this.previewImgList
        if (k == 0) return list;
        let start = list.slice(k, list.length);
        let end = list.slice(0, k);
        return start.concat(end);
      }
    }
  },
  mounted() {
  },
  methods: {
    myReview(val) {
      let that = this;
      that.choose = val;
      that.AppraisalStatus = val;
      console.log(val)
      if (val == 1) {
        that.$refs.review_icon1.src = '../../../static/images/icons/icon_thumbs_up.svg'
        that.$refs.review_icon2.src = '../../../static/images/icons/icon_thumbs_down_blue.svg'
      }
      else {
        that.$refs.review_icon2.src = '../../../static/images/icons/icon_thumbs_down.svg'
        that.$refs.review_icon1.src = '../../../static/images/icons/icon_thumbs_up_blue.svg'
      }
    },
    setExpress(e) {
      console.log(e);
      let that = this;
      this.$set(that.CardInfo, 'ExpressName', e.ShipperName);//快递公司名称
      this.$set(that.CardInfo, 'Expresscode', e.ShipperCode);//快递公司编码
    },
    saveData() {
      let that = this;
      let type = that.dialogType;
      let api = '', params = {}, fun = function (res) { };
      switch (type) {
        case 'EditShippingFee'://修改运费
          api = 'ModifyPostage';
          params['OrdersID'] = that.CardInfo.ID;
          if (that.Price > that.ShippingFeeMaxUsdPrice) {
            that.$message.warning(`Shipping fee must less than ${that.ShippingFeeMaxUsdPrice}`)
            return false;
          } else {
            params['ArrivalPay'] = that.ArrivalPay;//是否到付
            params['Price'] = that.ArrivalPay == 1 ? 0 : that.Price >= 0 ? that.$store.getters.priceExchange(that.Price, '', that.CardInfo.USDRate) : '';
            fun = function (res) {
              if (res.result) {
                that.$message({
                  showClose: true,
                  message: res.msg || 'Edit Shipping Fee successful',
                  type: "success",
                });
                that.DialogShow = false;
                that.$parent.getList();
              } else {
                // let Msg = res.msg || 'Edit Shipping Fee failed';
                // that.$message.error(Msg);
              }
            };
          }
          break;
        case 'Ship'://添加快递单号
          api = 'SetExpress';
          params = {
            // ...that.CardInfo,
            Expresscode: that.CardInfo.Expresscode,
            ExpressName: that.CardInfo.ExpressName,
            Express: that.CardInfo.Express,
            'OrderID': that.CardInfo.ID
          }
          fun = function (res) {
            if (res.result) {
              that.$message({
                showClose: true,
                message: res.msg || 'Add shipping successful',
                type: "success",
              });
              that.DialogShow = false;
              that.$parent.getList();
            } else {
              // let Msg = res.msg || 'Add shipping failed';
              // that.$message.error(Msg);
            }
          };
          break;
        case 'ChangeShippingInfo'://修改快递单号 
          api = 'SetExpress';
          params = {
            // ...that.CardInfo, 
            Expresscode: that.CardInfo.Expresscode,
            ExpressName: that.CardInfo.ExpressName,
            Express: that.CardInfo.Express,
            'OrderID': that.CardInfo.ID
          }
          fun = function (res) {
            if (res.result) {
              that.$message({
                showClose: true,
                message: res.msg || 'Change shipping info successful',
                type: "success",
              });
              that.DialogShow = false;
              that.$parent.getList();
            } else {
              // let Msg = res.msg || 'Change shipping info failed';
              // that.$message.error(Msg);
            }
          };
          break;
        case 'ToBeReviewed'://评价 / 添加订单评价
          api = 'Appraisal';
          params = {
            // 'UserApi': 'UserApi',
            'OrderID': that.CardInfo.ID,
            AppraisalType: that.AppraisalType,//评价类型	
            AppraisalStatus: that.AppraisalStatus,//是否好评	
            AppraisalContent: that.AppraisalContent//评价内容
          }
          fun = function (res) {
            if (res.result) {
              that.$message({
                showClose: true,
                message: res.msg || 'Appraisal successful',
                type: "success",
              });
              that.DialogShow = false;
              that.$parent.getList();
            } else {
              // let Msg = res.msg || 'Appraisal failed';
              // that.$message.error(Msg);
            }
          };
          break;
        case 'RestoreOrder'://拆分订单
          api = 'RestoreOrder';
          params = {
            'OrderID': that.CardInfo.ID
          }
          fun = function (res) {
            if (res.result) {
              that.$message({
                showClose: true,
                message: res.msg || 'Split Orders successful',
                type: "success",
              });
              that.DialogShow = false;
              that.$parent.getList();
            } else {
              // let Msg = res.msg || 'Appraisal failed';
              // that.$message.error(Msg);
            }
          };
          break;
        case 'CloseOrder'://关闭订单
          api = 'CloseOrder';
          params = {
            'OrderID': that.CardInfo.ID
          }
          fun = function (res) {
            if (res.result) {
              that.$message({
                showClose: true,
                message: res.msg || 'Close successful',
                type: "success",
              });
              that.DialogShow = false;
              that.$parent.getList();
            } else {
              // let Msg = res.msg || 'Appraisal failed';
              // that.$message.error(Msg);
            }
          };
          break;
      }

      that.$post(api, params)
        .then((res) => {
          console.log("axios-res:", res);
          fun(res);
        })
        .catch((err) => {
          console.log(err);
        });
      setTimeout(() => {
        that.AppraisalContent = ''
      }, 500);
    },
    setDialogType(type) {
      this.dialogType = type;
    },
    ////////
    OfferCheck(type) {
      let that = this;
      let msg = '';
      if (type == 'Appept') {
        msg = '<div class="p_txt">Do you want to Appept right now?</div>';
      } else {
        msg = '<div class="p_txt">Do you want to Refuse this item?</div>';
      }
      this.$confirm(msg, type, {
        dangerouslyUseHTMLString: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      }).then(() => {
        console.log(type)
        // console.log(that.CardInfo);
        if (type == 'Decline' || type == 'Appept') {
          let api = type == 'Decline' ? 'Refuse' : 'Approve';
          let params = {
            id: that.CardInfo['Bargain_ID']
          };
          if (api == 'Approve') { params['ApproveType'] = 1; }
          let fun = function (res) {
            //console.log(res)  
            let _type = 'success';
            if (res.result != 1) {
              _type = 'error';
            } else {
              that.$message({
                showClose: true,
                message: res.msg || _type,
                type: _type,
              });
            }
            that.OfferShow = false;
            that.$parent.GetDataOffer();//page:offer.vue
          };
          that.$post(api, params)
            .then((res) => {
              console.log("axios-res:", res);
              fun(res);
            })
            .catch((err) => {
              console.log(err);
            });
        }
        // Yes    
      }).catch(() => {
        // No
      });
    },
    OfferSave() {
      let that = this;
      let params = {
        // CommodityID: that.CardInfo['Bargain_ID'],
        CommodityID: that.CardInfo['ID'],
        ReceiveID: that.CardInfo['Bargain_ID'],
        Price: that.$store.getters.priceExchange(that.OfferPrice),
        BargainType: 2,
        Remark: '',
        Images: '',
      };
      that.$post('BargainAdd', params)
        .then((res) => {
          console.log("axios-res:", res);
          let _type = 'success';
          if (res.result != 1) {
            _type = 'error';
          } else {
            that.$message({
              showClose: true,
              message: res.msg || _type,
              type: _type,
            });
          }
          that.OfferShow = false;
          that.$parent.GetDataOffer();//page:offer.vue
        })
        .catch((err) => {
          console.log(err);
        });
    },
    DialogSwitch(page) {
      this.$emit('DialogSwitch', 'DialogOffer');
    },
    DialogOnClose(e) {
      // console.log("DialogOnClose")
      this.Price = "";
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.review_dialog_top {
  margin: 15px 0 0;
  display: flex;
}

.review_img {
  width: 88px;
  height: 88px;
  background: #f7f7f7;
  position: relative;
}

.review_img img {
  max-width: 88px;
  max-height: 88px;
  position: absolute;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.review_detail {
  width: 288px;
  margin: 0 0 0 8px;
}

.review_title {
  font-size: 16px;
  height: 36px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin: 0 0 36px 0;
}

.review_buyer {
  font-size: 14px;
  display: flex;
  align-content: center;
  align-items: center;
}

.review_buyer .headPortrait {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  margin: 0 5px 0 0;
}

.review_serve {
  margin: 24px 0;
}

.review_serve .el-button {
  height: 40px;
  width: 190px;
  padding: 0;
}

.review_textarea {
  margin: 0 0 10px 0;
}

.review_button {
  margin: auto;
}

.review_button img {
  width: 16px;
  height: 16px;
  margin: 0 2px 0 0;
}

.el-button>>>span {
  display: flex;
  font-size: 16px;
}

.review_button_div {
  display: flex;
  margin: auto;
}

/*  */

.contact_title {
  font-size: 18px;
}

.contact_box:last-child .contact_title {
  padding: 16px 0;
  font-size: 18px;
}

.el-collapse {
  border-top: none;
}

.el-collapse {
  margin: 3px 0 0;
}

.contact_title span {
  font-size: 16px;
  padding-left: 18px;
  margin-left: 16px;
  background: url(../../../static/images/icons/icon_chat.png) no-repeat;
  cursor: pointer;
}

.seller_answer_textarea {
  border: 1px solid #c8c8c8;
  border-radius: 5px;
  padding: 16px;
}

.seller_answer .el-textarea /deep/ .el-textarea__inner {
  border: none;
}

.seller_answer_textarea div,
.seller_answer_p {
  color: #a0a0a0;
  font-size: 12px;
}

.seller_answer_p {
  margin: 16px 0 8px;
}

.el-checkbox__label {
  font-size: 12px;
}

.el-dialog /deep/ .el-dialog__footer {
  padding: 10px 20px 20px;
  text-align: left;
  box-sizing: border-box;
}

.card_detail_box {
  display: flex;
  height: 88px;
  margin: 0 0 34px 0;
}

.card_detail_box img {
  width: 68.5px;
  height: 88px;
}

.card_detailbox {
  margin: 0 0 0 21px;
}

.card_detail {
  height: 36px;
  width: 100%;
  display: block;
}

.price {
  font-size: 14px;
  margin: 6px 0 12px;
}

.sPrice_box {
  display: flex;
  font-size: 16px;
}

.sPrice_box span {
  color: #a0a0a0;
}

.buyer_anwer {
  width: 100%;
  height: 230px;
  margin: 11px 0 0;
}

.buyer_name {
  height: 23px;
  line-height: 23px;
  color: #a0a0a0;
  font-size: 12px;
  box-shadow: 0px 2px 12px 1px rgba(0, 0, 0, 0.1);
  margin: 0 0 6px 0;
}

.anwer_list {
  display: flex;
  margin: 16px 0 0;
}

.anwer_list img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}

.anwer_message {
  height: 24px;
  background: #f7f7f7;
  border-radius: 2px;
  min-width: 150px;
  margin: 0 0 0 8px;
  padding: 6px 8px;
}

.anwer_box {
  height: 200px;
}

.enter_textarea {
  padding: 8px 12px;
}

.enter_textarea .el-textarea /deep/ .el-textarea__inner {
  background: #f7f7f7;
}

.feedback-detail {
  padding: 10px 0;
  max-height: 200px;
  overflow-y: auto;
  margin: 0 0 0 37px;
}

.Price_ {
  font-size: 12px;
}

.Price_p {
  font-size: 16px;
  font-weight: bold;
  margin: 0 0 0 2px;
}

.review_name_m {
  margin: 16px 0 0;
}

.review_name_m .review_buyer .headPortrait {
  width: 32px;
  height: 32px;
}

/deep/.review_name_m .review_buyer .headPortrait i {
  display: block;
  margin: 7px auto;
}

.evaluate_icon {
  width: 16px;
  height: 16px;
  margin: 0 0 0 6px;
}

.evaluate_good {
  background: url(../../../static/images/good.svg);
}

.evaluate_notgood {
  background: url(../../../static/images/not_good.svg) no-repeat;
}

.review_createDate {
  font-size: 12px;
}

.review_buyer_box {
  align-items: normal;
}

/deep/ .el-dialog {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 0px !important;
}

.split-tips-li {
  padding-left: 15px;
  line-height: 1.4;
}

.split-tips-li li {
  list-style: decimal;
  font-size: 12px;
}

.photos_list {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
}

.photo_block {
  width: 33.3%;
  padding: 5px;
}

.photo_img {
  width: 100%;
  height: 150px;
}

.photo_des {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/dialog-order.vue